import { useEffect, useState } from 'react';

export const useBlobText = (blob?: Blob, enabled: boolean = true): string | null => {
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    if (!blob || !enabled) {
      setText(null);
      return;
    }

    let active = true;
    setText(null);

    blob
      .text()
      .then((value) => {
        if (active) {
          setText(value);
        }
      })
      .catch(() => {
        if (active) {
          setText(null);
        }
      });

    return () => {
      active = false;
    };
  }, [blob, enabled]);

  return text;
};
